import React, { useEffect, useState } from 'react'
import Topbar from "../../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";

import { Table } from "../../../components/Table/Table";
import moment from "moment";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { useGlobalContext } from "../../../Services/PaginationGlobal";

export default function Deactivate() {
    const location = useLocation();
    const path = location.pathname?.replace("/", "");
    const { paginationData, setpaginationData } = useGlobalContext();
    const [pagination, setPagination] = useState({});

    const [OwnersCount, setOwnersCount] = useState(0);
    const [isShowReason, setShowReason] = useState({
        isView: false,
        data: ""
    });
    const [isActive, setIsActive] = useState( paginationData?.[path]?.active ??'Owner');
    const [owners, setOwners] = useState([]);
    const [userList, setUserList] = useState([]);


    const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);


  const storePaginationData = (activeTab)=>{
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], active:activeTab},
    }));
  }

    const getList = async () => {
        // let urlParams = `${search && "&search=" + search}${from && to && `&from_date=${from}&to_date=${to}`
        //     }`;
        const res = await get(`${URLS.OWNERSDELETEUSER}?page=${page}`);
        if (res?.status === "success") {
            console.log("owner response success", res);
            setPagination({
                current_page: page,
                last_page: res?.next ? page + 1 : page,
            });
            setOwnersCount(res?.count);
            setOwners(res?.data);
        }
    };
    const getUserList = async () => {
        // let urlParams = `${search && "&search=" + search}${from && to && `&from_date=${from}&to_date=${to}`
        //     }`;
        const res = await get(`${URLS.USERDELETEUSER}?page=${page}`);
        if (res?.status === "success") {
            console.log("owner response success", res);
            setPagination({
                current_page: page,
                last_page: res?.next ? page + 1 : page,
            });
            setOwnersCount(res?.count || 0);
            setUserList(res?.data);
        }
    };
    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "S.No",
                Cell: ({ row }) => {
                    const pageSize = 10;
                    return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
                },
            },
            {
                Header: "Owner",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return (
                        <div className="text-nowrap">
                            <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
                            <p style={{ color: "#AE55F5", fontWeight: "600" }}>
                                {row.original.code}
                            </p>
                        </div>
                    );
                },
            },
            {
                Header: " Reason",
                accessor: "delete_reason",
                Cell: ({ value, row }) => {
                    return <p onClick={() => setShowReason({ isView: true, data: value })} style={{ color: "#000", fontWeight: "600", border: "1px solid #000", borderRadius: "60px", padding: "5px", width: "25px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>i</p>;
                },
            },
            {
                Header: " Email ID",
                accessor: "email",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " Mobile Number",
                accessor: "mobile",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " WhatsUp Number",
                accessor: "whatsapp_no",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " Gender",
                accessor: "gender",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "State",
                accessor: "state_name",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "City",
                accessor: "city_name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Current City/Area",
                accessor: "pincode",
                Cell: ({ value, row }) => {
                    return <p>{value || "-"}</p>;
                },
            },
            {
                Header: "Status",
                accessor: "property_count",
                Cell: ({ value, row }) => {
                    return <p className="text-center text-nowrap">{value ?? "De-Active"}</p>;
                },
            },
            {
                Header: "Deactivate Date",
                accessor: "deleted_at",
                Cell: ({ value, row }) => {
                    return <p className="text-center">{moment(value).format("DD/MM/YYYY") ?? "-"}</p>;
                },
            },
        ],
        [page]
    );
    const columnsuser = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "S.No",
                Cell: ({ row }) => {
                    const pageSize = 10;
                    return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
                },
            },
            {
                Header: "User ID",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return (
                        <div className="text-nowrap">
                            <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
                            <p style={{ color: "#AE55F5", fontWeight: "600" }}>
                                {row.original.code}
                            </p>
                        </div>
                    );
                },
            },
            {
                Header: " Reason",
                accessor: "delete_reason",
                Cell: ({ value, row }) => {
                    return <p onClick={() => setShowReason({ isView: true, data: value })} style={{ color: "#000", fontWeight: "600", border: "1px solid #000", borderRadius: "60px", padding: "5px", width: "25px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>i</p>;
                },
            },
            {
                Header: " Email ID",
                accessor: "email",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " Mobile Number",
                accessor: "mobile",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " WhatsUp Number",
                accessor: "whatsapp_no",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: " Gender",
                accessor: "gender",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "State",
                accessor: "state_name",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "City",
                accessor: "city_name",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Current City/Area",
                accessor: "current_area",
                Cell: ({ value, row }) => {
                    return <p>{value || "-"}</p>;
                },
            },
            {
                Header: "Pin Code",
                accessor: "pin_code",
                Cell: ({ value, row }) => {
                    return <p>{value || "-"}</p>;
                },
            },
            {
                Header: "Booking count",
                accessor: "booking_count",
                Cell: ({ value, row }) => {
                    return <p className="text-center">{value ?? "-"}</p>;
                },
            },
            {
                Header: "Deactivate Date",
                accessor: "deleted_at",
                Cell: ({ value, row }) => {
                    return <p className="text-center">{moment(value).format("DD/MM/YYYY") ?? "-"}</p>;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (

                        <div className="text-nowrap" style={{ backgroundColor: "red", color: "white", border: "none", padding: "5px 10px", borderRadius: "5px", fontSize: "12px" }}>

                            De-active
                        </div>
                    );
                },
            },
            // {
            //     Header: "Action",
            //     accessor: "",
            //     Cell: ({ value, row }) => {
            //         return (
            //             <React.Fragment>
            //                 <div className="d-flex ac-js gap-3">
            //                     {/* {givenpermissions?.includes("CAN-View-ADMINS") && ( */}
            //                     {row.original.role !== "Super Admin" && (
            //                         <button
            //                             onClick={() => {
            //                                 navigate("/add-owner", {
            //                                     state: { type: "view", id: row.original.id },
            //                                 });
            //                                 // AdminView(row.original.id, "view");
            //                             }}
            //                             className="cust-btn "
            //                         >
            //                             <img src={view_icon} alt="" className=" edit-btn " />
            //                         </button>
            //                     )}
            //                     {/* )} */}
            //                     {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
            //                     <button
            //                         onClick={() => {
            //                             navigate("/add-owner", {
            //                                 state: {
            //                                     type: "edit",
            //                                     id: row.original.id,
            //                                 },
            //                             });
            //                             // AdminView(row.original.id, "edit");
            //                         }}
            //                         className="cust-btn "
            //                     >
            //                         <img src={edit_icon} alt="" className=" edit-btn " />
            //                     </button>
            //                     {/* )}
            //     {givenpermissions?.includes("CAN-Delete-ADMINS") && ( */}
            //                     {row.original.role !== "Super Admin" && (
            //                         <button
            //                             onClick={() => {
            //                                 setPopup(row.original.id);
            //                             }}
            //                             // onClick={() => setDeletePopup(row.original.id)}
            //                             className="cust-btn "
            //                         >
            //                             <img src={delete_icon} alt="" className=" edit-btn " />
            //                         </button>
            //                     )}
            //                     {/* )} */}
            //                 </div>
            //             </React.Fragment>
            //         );
            //     },
            // },
        ],
        [page]
    );
    useEffect(() => {
        getList()
    }, [page])
    useEffect(() => {
        if (isActive == "User") {
            getUserList()
        }
    }, [page, isActive])


    console.log("owners", owners);

    return (
        <>
            <Topbar header={"User List"} subHead={"Owner"} />



            <div className="d-flex ac-jf">
                <div>
                    <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mb-4">
                        Total:{OwnersCount}
                    </h2>
                    <div className='gap-3 d-flex'>
                        {['Owner', 'User'].map((item) => {
                            return (
                                <button style={{
                                    background: isActive === item ? "#6B00D8" : "#adadad",
                                    color: "#fff",
                                    padding: "10px 16px",
                                    borderRadius: 9,
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    border: "none"
                                }} onClick={() =>{storePaginationData(item); setIsActive(item)}}>{item}</button>
                            )
                        })}
                    </div>
                </div>

            </div >
            {
                isActive === 'Owner' ? <Table
                    columns={columns}
                    setPageno={setPage}
                    pagecount={pagination}
                    data={owners}
                    show={true}
                /> :


                    <Table
                        columns={columnsuser}
                        setPageno={setPage}
                        pagecount={pagination}
                        data={userList}
                        show={true}
                    />
            }
            {isShowReason?.isView && (
                <div className="img-popup-design" >
                    <div className="img-popup" style={{ position: "relative" }}>
                        <div style={{ position: "absolute", right: "20px", top: "20px", border: "1px solid #adadad", borderRadius: "50%", width: "20px", height: "20px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <p style={{ cursor: "pointer" }} onClick={() => setShowReason({ isView: false, data: "" })}>X</p>
                        </div>
                        <h2 className="f4 mt-4" style={{ textAlign: "left" }}>Reason</h2>
                        <p className="f3 mt-4" style={{ textAlign: "left" }}>{isShowReason?.data}</p>
                        <div className="d-flex ac-jb px-2 mt-5">
                            {/* <button onClick={() => setPopup(false)} className="add-btn w-40">
                                No
                            </button>
                            <button onClick={handleLogout} className="back-btn f2 w-40">
                                {loading ? "Loading..." : "Confirm"}
                            </button> */}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
